import { render, staticRenderFns } from "./layout-small.vue?vue&type=template&id=6fb306f0"
import script from "./layout-small.vue?vue&type=script&lang=js"
export * from "./layout-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports